const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OmnichannelQuery: any = {
    StorePickupList: Backofficebff + '/v1/omnichannel/storepickuplist',
    FilterStorePickup: Backofficebff + '/v1/omnichannel/filterstorepickup',
    StoreList: Backofficebff + '/v1/omnichannel/storelist',
    UpdateStoreList: Backofficebff + '/v1/omnichannel/updateStoreList',
    GetServiceManagment: Backofficebff + '/v1/omnichannel/get-storestatus',
    GetOperationFlagValue: Backofficebff + '/v1/omnichannel/getoperationflagvalue',
    GetStoreCity: Backofficebff + '/v1/omnichannel/getstorecity',
    GetStoreCounty: Backofficebff + '/v1/omnichannel/getstorecounty',
    GetStore: Backofficebff + '/v1/omnichannel/getstore',
};
